module.exports = __webpack_public_path__ + "img/icon-custom-megphone.1870df29.svg";